var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bread-m"},[_c('el-breadcrumb',{staticClass:"bread-list",attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.lists),function(list,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":list.path ? { path: list.path } : ''}},[_vm._v(_vm._s(list.name || '首页'))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }